import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { Form, Field } from 'react-final-form';
import User from '_class/User';
import { clearSearch, searchTeacher } from 'actions/search';
import { Spinner } from 'UI';
import { Search } from 'UI/Inputs';
import { Button, Radio } from '@haldor/ui';
import './_SelectUserForm.scss';

var SelectUserForm = function SelectUserForm(props) {
  var translate = useTranslate();
  var dispatch = useDispatch();
  var teachers = useSelector(function (state) {
    return state.Search.teachers;
  });

  var onSearch = function onSearch(values) {
    if (values.query == '') {
      dispatch(clearSearch());
      return true;
    }

    if (values.query.length < 3) {
      return false;
    }

    dispatch(searchTeacher(values.query));
  };

  var onSubmit = function onSubmit(values) {
    return new Promise(function (resolve) {
      if (props.onSubmit != null) {
        props.onSubmit(values).then(function () {
          resolve(1);
        });
        dispatch(clearSearch());
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form select-user-form"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    mutators: {
      clearUserId: function clearUserId(args, state, utils) {
        utils.changeValue(state, 'userId', function () {
          return '';
        });
      }
    },
    render: function render(_ref) {
      var _form$getFieldState;

      var handleSubmit = _ref.handleSubmit,
          form = _ref.form,
          submitting = _ref.submitting,
          valid = _ref.valid;
      var userId = (_form$getFieldState = form.getFieldState('userId')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "form-component"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, translate('Add schedule'))), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1.35rem'
        }
      }, /*#__PURE__*/React.createElement(Search, {
        onSubmit: function onSubmit(values) {
          form.mutators.clearUserId();
          onSearch(values);
        },
        placeholder: translate('Search for teacher'),
        allowEmpty: true
      })), teachers.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row user-list"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#f2f3f2',
          padding: '1rem'
        }
      }, teachers.map(function (teacher) {
        if (props.forbiddenUsers != null) {
          if (props.forbiddenUsers.indexOf(teacher.userId) > -1) {
            return null;
          }
        }

        var user = new User(teacher);
        return /*#__PURE__*/React.createElement("div", {
          className: "user"
        }, /*#__PURE__*/React.createElement(Field, {
          component: Radio,
          name: "userId",
          label: user.getName(),
          optionValue: teacher.userId,
          key: teacher.userId
        }));
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1.35rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || userId == null || userId == ''
      }, submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null, translate('Add'))));
    }
  }));
};

export default SelectUserForm;